export const custom = {
	institution: 'Provincia Autonoma - Bolzano - Alto Adige',
	logoSrc: 'adler.svg',
	availableLanguages: [
		{ code: 'it', label: 'Italiano' },
		{ code: 'de', label: 'Deutsch' },
	],
	documentLanguages: ['mul', 'ita', 'deu'],
};
